import React from 'react'
import tw from 'tailwind-styled-components'
import {cn} from '@containers/html-utils'

type LinkProps = {
  children: React.ReactNode
  onClick?: () => void
  className?: string
}

const TwLink = tw.div<{$small?: boolean}>`
  flex
  items-center
  cursor-pointer
  text-action-default
  w-max
  hover:text-action-hover
`

export const Link = (props: LinkProps): React.ReactElement => {
  const {children, onClick, className} = props

  return (
    <TwLink className={cn(className)} onClick={onClick}>
      {children}
    </TwLink>
  )
}

type LinkAsButtonProps = LinkProps & {
  className?: string
  classNameContainer?: string
}

export const LinkAsButton = (props: LinkAsButtonProps): React.ReactElement => {
  const {...rest} = props

  const classNameContainer = props.classNameContainer ?? 'px-8 py-4'
  const className = props.className ?? 'leading-6'

  return (
    <div className={cn(classNameContainer)}>
      <Link className={className} {...rest} />
    </div>
  )
}
